var map = {
	"./bh-ico.svg": 793,
	"./bonus-ico.svg": 794,
	"./deposit-ico.svg": 795,
	"./deposit-ico.webp": 1831,
	"./edit-icon.svg": 796,
	"./fb-ico.svg": 797,
	"./instant-rebate-ico.svg": 798,
	"./mall-ico.svg": 799,
	"./msg-ico.svg": 800,
	"./pi-ico.svg": 801,
	"./rf-ico.svg": 802,
	"./rh-ico.svg": 803,
	"./th-ico.svg": 804,
	"./vip-ico.svg": 805,
	"./withdrawal-ico.svg": 806,
	"./withdrawal-ico.webp": 1832,
	"./wl-ico.svg": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1830;